import { ScopeSelectKeys } from './models'
import { TRANSLATION_KEYS } from './translations/TRANSLATION_KEYS'

export const COMPOSED_REPORT_MAPPING_ID = 188
export const COMPOSED_REPORT_SOB_TRACKER_MAPPING_ID = 189
export const COMPOSED_REPORT_FYEAR_SOB_TRACKER_MAPPING_ID = 201

export const mapScopeKeyToLabel = {
  [ScopeSelectKeys.All]: 'All',
  [ScopeSelectKeys.WWTopOpsPartners]: 'WW Top OPS Partners',
  [ScopeSelectKeys.WWTopBpsPartners]: 'WW Top BPS Partners',
  [ScopeSelectKeys.MarketOpsTopPartners]: 'Market Top OPS Partners',
  [ScopeSelectKeys.MarketBpsTopPartners]: 'Market Top BPS Partners',
  [ScopeSelectKeys.TopDistributors]: 'Top Distributors',
  [ScopeSelectKeys.Manual]: 'Manual search/selection',
  [ScopeSelectKeys.ManualGlobal]: 'Global Partner',
}

export const mapFieldToTranslation = {
  Scope: TRANSLATION_KEYS.openFilterScopeField,
  Products: TRANSLATION_KEYS.openFilterProducts,
  Pbms: TRANSLATION_KEYS.openFilterPbms,
  AmplifyMembership: TRANSLATION_KEYS.openFilterAmplifyMembership,
  Managers: TRANSLATION_KEYS.openFilterManagers,
  Geo: TRANSLATION_KEYS.openFilterGeo,
  PartnersType: TRANSLATION_KEYS.openFilterPartnersType,
}
